export function parseCsv(text) {
  if (!text) return { headers: [], rows: [] };
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;

  const pushField = () => {
    row.push(field);
    field = "";
  };

  const pushRow = () => {
    if (row.length === 1 && row[0].trim() === "") {
      row = [];
      return;
    }
    rows.push(row);
    row = [];
  };

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch === '"') {
      if (inQuotes && text[i + 1] === '"') {
        field += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }
    if (ch === "," && !inQuotes) {
      pushField();
      continue;
    }
    if ((ch === "\n" || ch === "\r") && !inQuotes) {
      if (ch === "\r" && text[i + 1] === "\n") {
        i++;
      }
      pushField();
      pushRow();
      continue;
    }
    field += ch;
  }
  pushField();
  pushRow();

  if (rows.length === 0) return { headers: [], rows: [] };

  const rawHeaders = rows.shift();
  const headers = rawHeaders.map((h) => h.trim());
  const lowerHeaders = headers.map((h) => h.toLowerCase());

  const dataRows = rows
    .filter((r) => r.some((v) => v.trim() !== ""))
    .map((r) => {
      const obj = {};
      lowerHeaders.forEach((h, idx) => {
        obj[h] = (r[idx] || "").trim();
      });
      return obj;
    });

  return { headers, rows: dataRows };
}

export function toCsv(headers, rows) {
  const esc = (val) => {
    const str = val == null ? "" : String(val);
    if (str.includes('"') || str.includes(",") || str.includes("\n")) {
      return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
  };
  const headLine = headers.map(esc).join(",");
  const body = rows
    .map((r) => headers.map((h) => esc(r[h])).join(","))
    .join("\n");
  return [headLine, body].filter(Boolean).join("\n");
}

export function downloadCsv(filename, content) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
